import { CheckCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { Button, Divider, Popover } from "antd";
import { FC, useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";
import { SingleTaskDisplay } from "./SingleTaskDisplay";
import { TaskStatus, useTasksCollectorHelper } from "./use-tasks-collector-helper";
import styles from "./TaskDisplay.module.less";

export const TaskDisplay: FC = () => {
  useTranslation();
  const { tasks, hideTask } = useTasksCollectorHelper();

  const [ongoingTasks, finishedTasks] = useMemo(
    () => {
      const ongoing: TaskStatus[] = [];
      const finished: TaskStatus[] = [];

      tasks.forEach((task) => {
        if (task.success + task.failed === task.total)
          finished.push(task);
        else
          ongoing.push(task);
      });
      return [ongoing, finished];
    },
    [tasks],
  );

  const popoverContent = useMemo(
    () => (
      <div className={styles.popover}>
        <Divider size="small" orientation="start">
          <Trans ns="app" i18nKey="titleBar.taskDisplay.ongoingTasks" values={{ count: ongoingTasks.length }}/>
        </Divider>
        {ongoingTasks.map((task) => <SingleTaskDisplay key={task.id} task={task} hideTask={hideTask}/>)}
        {ongoingTasks.length === 0 && <Trans ns="app" i18nKey="titleBar.taskDisplay.noTasks"/>}
        {finishedTasks.length > 0 && (
          <>
            <Divider orientation="start"><Trans ns="app" i18nKey="titleBar.taskDisplay.completedTasks" values={{ count: finishedTasks.length }}/></Divider>
            {finishedTasks.map((task) => <SingleTaskDisplay key={task.id} task={task} hideTask={hideTask}/>)}
          </>
        )}
      </div>
    ),
    [finishedTasks, hideTask, ongoingTasks],
  );

  const buttonIcon = useMemo(
    () => {
      if (ongoingTasks.length > 1) return <LoadingOutlined/>;
      else if (ongoingTasks.length === 0) return <CheckCircleOutlined/>;
      return undefined;
    },
    [ongoingTasks.length],
  );

  return (
    <>
      {(ongoingTasks.length !== 0 || finishedTasks.length !== 0) && (
        <Popover content={popoverContent} trigger="click" placement="bottomRight">
          <Button type="text" icon={buttonIcon}>
            {ongoingTasks.length === 1 && <SingleTaskDisplay task={ongoingTasks[0]} displayInTitleBar/>}
            {ongoingTasks.length > 1 && <Trans ns="app" i18nKey="titleBar.taskDisplay.ongoingTasks" values={{ count: ongoingTasks.length }}/>}
            {ongoingTasks.length === 0 && <Trans ns="app" i18nKey="titleBar.taskDisplay.completedTasks" values={{ count: finishedTasks.length }}/>}
          </Button>
        </Popover>
      )}
    </>
  );
};
